import { createContext } from "react";

//#region src/components/cover/CoverProviderContext.tsx
const CoverProviderContext = createContext({ coverPageTarget: void 0 });

//#endregion
export { CoverProviderContext };